import {ContactInfo, LocationInfo} from "./ProjectDetails";

export interface MemberClientBranch extends Branch {
  clientId: string;
}

export interface Branch extends LocationInfo, ContactInfo {
  branchNumber: number;
  branchSortValue: number;

  name: string;
  id: string;

  fullName: string;
  useInReport: boolean;

  countryCode?: string;
  zipCode?: string;
  city?: string;
  street?: string;
  houseNumber?: string;

  logoFile?: string | null;
  logoScaleFactor?: number;

  deleted?: boolean;
}

/**
 * Branch number a device carries when it belongs to no branch: deleting a branch
 * moves its devices to "0" rather than clearing the field.
 */
export const UNASSIGNED_BRANCH_NUMBER = "0";

export function getBranchName(branch?: Branch | null) {
  if (!branch) {
    return "-"
  }

  return branch.name;
}
